import { render, staticRenderFns } from "./LastObjectCard.vue?vue&type=template&id=2d68228a&scoped=true&"
import script from "./LastObjectCard.vue?vue&type=script&lang=js&"
export * from "./LastObjectCard.vue?vue&type=script&lang=js&"
import style0 from "./LastObjectCard.vue?vue&type=style&index=0&id=2d68228a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68228a",
  null
  
)

export default component.exports